export const ActionTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_FILTER_PRODUCT: "SET_FILTER_PRODUCT",
  SET_PRODUCT_CATEGORY: "SET_PRODUCT_CATEGORY",
  SET_CART: "SET_CART",
  SET_TABLE_DATA: "SET_TABLE_DATA",
  SET_SELECT_DATA: "SET_SELECT_DATA",
  UPDATE_TABLE_DATA: "UPDATE_TABLE_DATA",
  SET_CURRENT_CART: "SET_CURRENT_CART",
  DISCOUNT_CURRENT_CART: "DISCOUNT_CURRENT_CART",
  EMPTY_CURRENT_CART: "EMPTY_CURRENT_CART",
  ADD_TO_CART: "ADD_TO_CART",
  INCREASE_QUANTITY_CART: "INCREASE_QUANTITY_CART",
  DECREASE_QUANTITY_CART: "DECREASE_QUANTITY_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  CALCULATE_CART: "CALCULATE_CART",
  SET_TENDER: "SET_TENDER",
  SET_PAYMENT: "SET_PAYMENT",
  SET_RECENTLY_ADDED: "SET_RECENTLY_ADDED",
  UPDATE_PAYMENT: "UPDATE_PAYMENT",
  SET_LOGIN_TOKEN: "SET_LOGIN_TOKEN",
  SET_SCREEN_LOCK: "SET_SCREEN_LOCK",
  SET_SCREEN_UNLOCK: "SET_SCREEN_UNLOCK",
  SET_SCREEN_AUTH: "SET_SCREEN_AUTH",
  SET_LOGOUT: "SET_LOGOUT",
  SET_LOADING: "SET_LOADING",
  SET_COMPANY_INFO: "SET_COMPANY_INFO",
  CARTDATAOLD: "CARTDATAOLD",
  SET_MEMBERSHIP: "SET_MEMBERSHIP",
};
